export const TIMESHEET_TOAST_MESSAGE = {
  UPDATED_SUCCESS: "Time sheet Updated Successfully",
};

export const REPORT_ACTIONS_TOAST = {
  VERIFIED_STATUS_SUCCESS: "Verified Status Changed Successfully",
  NOTE_UPDATED_SUCCESS: "Note Updated Successfully",
  REPORT_CHANGED_SUCCESS: "Report Changed Successfully",
  BREAKS_MODIFIED_SUCCESS: "Breaks Modified Successfully",
  BREAKS_UPDATED_SUCCESS: "Breaks Updated Successfully",
  ADDED_HOLIDAY_SUCCESS: "Holidays Has Been Added Successfully",
  BREAKS_DELETED_SUCCESS: "Break Has Been Deleted Successfully",
  SHIFTS_UPDATED_SUCCESS: "Shifts Updated Successfully",
  SHIFTS_UPDATED_FAILED: "Failed to update shifts",
  INVALID_BREAK: "Please enter valid break",

  HOLIDAY_MODIFIED_SUCCESS: " Modified Successfully",
  HOLIDAY_UPDATED_SUCCESS: "Holidays Has Been Updated Successfully",
  HOLIDAY_DELETED_SUCCESS: "Holiday Deleted Successfully",
};
